

import React, { useRef, useEffect, useState } from "react";
import "./ReelsSection.css"; // Fixed import (don't use styles object for regular CSS)

const ReelsSection = () => {

    const reelsContainerRef = useRef(null);

    const [campaigns, setCampaigns] = useState([]);
    const [filteredCampaigns, setFilteredCampaigns] = useState([]);
    const [activeCategory, setActiveCategory] = useState("all");
    const [activeIndex, setActiveIndex] = useState(0);
    const [isLiking, setIsLiking] = useState(false);

    const token = localStorage.getItem("authToken");
    const customerId = localStorage.getItem("customerId");

    const categories = [
        { id: "all", label: "All", },
        { id: "FOOD_AND_BEVERAGES", label: "Food", },
        { id: "CATERING", label: "Catering", },
        { id: "LOGISTICS", label: "Logistics", },
        { id: "GROCERY", label: "Grocery", }
    ];

    const handleLike = async (campaignId, currentlyLiked) => {
        try {
            setIsLiking(true);

            setFilteredCampaigns(prevCampaigns =>
                prevCampaigns.map(campaign =>
                    campaign.id === campaignId
                        ? { ...campaign, likedByCurrentUser: !currentlyLiked }
                        : campaign
                )
            );

            setCampaigns(prevCampaigns =>
                prevCampaigns.map(campaign =>
                    campaign.id === campaignId
                        ? { ...campaign, likedByCurrentUser: !currentlyLiked }
                        : campaign
                )
            );

            const response = await fetch(
                "https://backend.maamaas.com/promotions/api/user/campaign/like",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        campaignId: campaignId,
                        customerId: customerId,
                        interactionType: "LIKE"
                    })
                }
            );

            if (!response.ok) {
                setFilteredCampaigns(prevCampaigns =>
                    prevCampaigns.map(campaign =>
                        campaign.id === campaignId
                            ? { ...campaign, likedByCurrentUser: currentlyLiked }
                            : campaign
                    )
                );

                setCampaigns(prevCampaigns =>
                    prevCampaigns.map(campaign =>
                        campaign.id === campaignId
                            ? { ...campaign, likedByCurrentUser: currentlyLiked }
                            : campaign
                    )
                );
            }
        } catch (error) {
            setFilteredCampaigns(prevCampaigns =>
                prevCampaigns.map(campaign =>
                    campaign.id === campaignId
                        ? { ...campaign, likedByCurrentUser: currentlyLiked }
                        : campaign
                )
            );

            setCampaigns(prevCampaigns =>
                prevCampaigns.map(campaign =>
                    campaign.id === campaignId
                        ? { ...campaign, likedByCurrentUser: currentlyLiked }
                        : campaign
                )
            );
        } finally {
            setIsLiking(false);
        }
    };

    const fetchCampaigns = async () => {
        try {
            const response = await fetch(
                `https://backend.maamaas.com/promotions/api/user/active/campaigns?customerId=${customerId}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            const data = await response.json();

            const campaignsArray = Array.isArray(data)
                ? data
                : Array.isArray(data?.data)
                    ? data.data
                    : [];

            setCampaigns(campaignsArray);
            setFilteredCampaigns(campaignsArray);

            campaignsArray.forEach(async (campaign) => {
                try {

                } catch (err) {
                    //console.log("Campaign view API error:", err);
                }
            });

        } catch (error) {
            setCampaigns([]);
            setFilteredCampaigns([]);
        }
    };

    useEffect(() => {
        fetchCampaigns();
    }, []);

    const handleCategoryChange = (categoryId) => {
        setActiveCategory(categoryId);
        setActiveIndex(0);

        if (categoryId === "all") {
            setFilteredCampaigns(campaigns);
            return;
        }

        const filtered = campaigns.filter(
            (item) => item.appType === categoryId
        );

        setFilteredCampaigns(filtered);
    };

    const reelsData = (Array.isArray(filteredCampaigns) ? filteredCampaigns : []).map((item) => ({
        id: item.id,
        imageUrl: item.imageUrl,
        campaignName: item.campaignName,
        description: item.description,
        startDate: item.startDate,
        endDate: item.endDate,
        discount: item.discountPercentage,
        appType: item.appType,
        likedByCurrentUser: item.likedByCurrentUser || false,
        likesCount: item.likesCount || 0
    }));

    useEffect(() => {
        if (!reelsContainerRef.current || reelsData.length === 0) return;

        const interval = setInterval(() => {
            const container = reelsContainerRef.current;
            const nextIndex = activeIndex + 1 >= reelsData.length ? 0 : activeIndex + 1;
            const reelHeight = container.clientHeight;

            container.scrollTo({
                top: reelHeight * nextIndex,
                behavior: "smooth"
            });

            setActiveIndex(nextIndex);
        }, 5000);

        return () => clearInterval(interval);
    }, [activeIndex, reelsData]);

    // Handle comment click
    const handleComment = (itemId) => {
        // Add your comment logic here
    };

    // Handle share click
    const handleShare = (itemId) => {
        // Add your share logic here
    };

    return (
        <div className="ms-reels-section">
            <div className="ms-categories-tabs">
                {categories.map((category) => (
                    <button
                        key={category.id}
                        className={`ms-category-tab ${activeCategory === category.id ? "ms-active" : ""}`}
                        onClick={() => handleCategoryChange(category.id)}
                    >
                        <span className="material-icons-round">{category.icon}</span>
                        <span className="ms-tab-label">{category.label}</span>
                    </button>
                ))}
            </div>

            <div className="ms-reels-container" ref={reelsContainerRef}>
                {reelsData.length === 0 && (
                    <div className="ms-no-campaigns">
                        No Campaigns Available
                    </div>
                )}

                {reelsData.map((item) => (
                    <div key={item.id} className="ms-reel-item">
                        <div className="ms-ad-container">
                            <img
                                src={item.imageUrl}
                                alt={item.campaignName}
                                className="ms-ad-images"
                            />

                            <div className="ms-ad-brand-info">
                                <div className="ms-ad-brand-details">
                                    <span className="ms-sponsored-tag">Sponsored</span>
                                    <span className="ms-ad-brand-name">{item.campaignName}</span>
                                    <span className="ms-ad-product-name">{item.description}</span>
                                </div>
                            </div>

                            <div className="ms-reel-actions">
                                {/* Like Button */}
                                <div
                                    className="ms-action-item"
                                    onClick={() => handleLike(item.id, item.likedByCurrentUser)}
                                    style={{ cursor: isLiking ? 'not-allowed' : 'pointer', opacity: isLiking ? 0.7 : 1 }}
                                >
                                    <span
                                        className="material-icons-round ms-action-icon"
                                        style={{
                                            color: item.likedByCurrentUser ? '#ff3b30' : 'white',
                                            transition: 'color 0.2s ease'
                                        }}
                                    >
                                        {item.likedByCurrentUser ? 'favorite' : 'favorite_border'}
                                    </span>
                                    <span className="ms-action-count">
                                        {item.likesCount > 0 ? item.likesCount : 'Like'}
                                    </span>
                                </div>

                                {/* Comment Button */}
                                <div
                                    className="ms-action-item"
                                    onClick={() => handleComment(item.id)}
                                >
                                    <span className="material-icons-round ms-action-icon">
                                        chat_bubble_outline
                                    </span>
                                    <span className="ms-action-count">Comment</span>
                                </div>

                                {/* Share Button */}
                                <div
                                    className="ms-action-item"
                                    onClick={() => handleShare(item.id)}
                                >
                                    <span className="material-icons-round ms-action-icon">
                                        send
                                    </span>
                                    <span className="ms-action-count">Share</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReelsSection;